import {
  SPONSORSHIP_TYPES,
  type SponsorshipType,
} from "lib/constants/sponsorship";

/**
 * Sponsorship type constants
 */
export { SPONSORSHIP_TYPES };
export type { SponsorshipType };

/**
 * Feed tab identifiers
 */
export const FEED_TABS = {
  POPULAR: "popular",
  FREE_TO_READ: "free",
  COLLABORATIONS: "collaborations",
} as const;

export type FeedTab = (typeof FEED_TABS)[keyof typeof FEED_TABS];

/**
 * Default tab labels (can be overridden by DatoCMS values)

 */
export const DEFAULT_TAB_LABELS = {
  [FEED_TABS.POPULAR]: "Popular",
  [FEED_TABS.FREE_TO_READ]: "Free to read",
  [FEED_TABS.COLLABORATIONS]: "Collaborations",
} as const;

/**
 * Article classification statuses
 */
export const ARTICLE_STATUS = {
  PRO: "pro",
  SPONSORED: "sponsored",
  FREE: "free",
} as const;

export type ArticleStatus =
  (typeof ARTICLE_STATUS)[keyof typeof ARTICLE_STATUS];

/**
 * Determine article status for styling
 * @param isProContent - Article.isProContent
 * @param isSponsored - Article.isSponsored
 */
export const getArticleStatus = (
  isProContent: boolean,
  isSponsored: boolean
): ArticleStatus => {
  if (isProContent) return ARTICLE_STATUS.PRO;
  if (isSponsored) return ARTICLE_STATUS.SPONSORED;
  return ARTICLE_STATUS.FREE;
};

/**
 * Border color mapping for articles
 */
export const ARTICLE_BORDER_COLORS: Record<ArticleStatus, string> = {
  [ARTICLE_STATUS.PRO]: "border-pro",
  [ARTICLE_STATUS.SPONSORED]: "border-brand-sifted",
  [ARTICLE_STATUS.FREE]: "border-brand-sifted",
} as const;

/**
 * CSS classes for typography
 */
export const TYPOGRAPHY_CLASSES = {
  TITLE: "text-accent-16",
  SUBTITLE: "font-emphasis-16",
  TAG: "text-assist-14",
  DATE: "text-assist-14",
  BREADCRUMB: "text-assist-14",
} as const;

/**
 * Spacing constants
 */
export const SPACING = {
  NONE: "0",
  SMALL: "4px",
  MEDIUM: "8px",
  LARGE: "16px",
  XLARGE: "32px",
} as const;
